<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('notes')"
      :columns="columns"
      :column_search="true"
      resource_url="/note/note/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create_note") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar notas -->
    <note-modal ref="note_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import NoteModal from "./note_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
} from "@/utils";

export default {
  name: "NotesDatatable",
  components: { GenericTable, NoteModal },
  data() {
    return {
      columns: [
        {
          title: this.$t("title"),
          name: "title",
          searchable: true,
          width: "30%",
          data: (row) => row.title || "",
        },
        {
          title: this.$t("content"),
          name: "content",
          searchable: true,
          width: "25%",
          data: (row) => {
            if (row.content) {
              return row.content.length > 100
                ? row.content.substring(0, 100) + "..."
                : row.content;
            }
            return "";
          },
        },
        {
          title: this.$t("category"),
          width: "15%",
          data: (row) => {
            if (row.category) {
              return `<span class="tag" style="background-color: ${row.category.color};">${row.category.name}</span>`;
            }
            return "";
          },
        },
        {
          title: this.$t("priority"),
          width: "10%",
          data: (row) => {
            const priorityColors = {
              high: "is-danger",
              medium: "is-warning",
              low: "is-info",
            };
            const priorityClass = priorityColors[row.priority] || "is-light";
            return `<span class="tag ${priorityClass}">${this.$t(
              row.priority + "_priority"
            )}</span>`;
          },
        },
        {
          title: this.$t("status"),
          width: "10%",
          data: (row) => {
            const statusColors = {
              draft: "is-info",
              published: "is-success",
              archived: "is-dark",
            };
            const statusClass = statusColors[row.status] || "is-light";
            return `<span class="tag ${statusClass}">${this.$t(
              row.status
            )}</span>`;
          },
        },
        {
          title: this.$t("actions"),
          width: "10%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.note_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete note?"),
                    v,
                    () => {
                      del("/note/note", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.note_modal.show_modal();
    },
    edit(row) {
      this.$refs.note_modal.show_modal(row.uuid);
    },
    delete(row) {
      confirm_deletion_dialog(this.$t("are_you_sure_delete"), this, () => {
        del("/note/note", { uuid: row.uuid })
          .then(() => {
            this.refresh_datatable();
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
};
</script>
